import { put } from 'redux-saga/effects';
import { userActions } from 'Constants/UserActions';
import { resetUploadFile } from 'Store/Areas/FileUpload/FileUploadActions';
import { fileStatuses } from 'Constants/FileStatuses';
import { setCustomReportFileName } from 'Store/Areas/Export/ExportActions';
import SignalrStrategyHandler from './SignalrStrategyHandler';

export const customReportFileUploadHandler = new SignalrStrategyHandler(
  userActions.CustomReportFileUpload,
  function* handler(payload, action) {
    if (payload.error) {
      yield this.handleError(action);
    } else {
      yield put(resetUploadFile());
      switch (payload.fileStatus) {
        case fileStatuses.corrupt:
          yield this.handleCorruptFile(action);
          break;
        case fileStatuses.failedScan:
          yield this.handleVirusDetected();
          break;
        case fileStatuses.passedScan:
          yield put(setCustomReportFileName(payload.cloudRef, payload.originalFileName));
          break;
        default:
      }
    }
  },
);
